import Modal from "/WebInterface/new-ui/modules/modal.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import copyLinkTemplate from "./template.js";

export const initCopyLink = (path) => {
  new Modal({
    title: "Copy Link",
    body: copyLinkTemplate({}),
    uniqueId: "copy-link-modal",
  });

  const copyLinkTextArea = _$("#copyLinkTextArea");
  copyLinkTextArea.val(utils.decodeURILocal(path));
  copyLinkTextArea.el().select();
};
